import React, { FC, useEffect } from "react";
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { LinkType } from "../../types";
import Link from "../link/Link";

// Interface

export interface LinkListProps {
  items?: LinkType[];
  variant?: "primary" | "secondary";
  onClick?: () => void;
}

interface StyledLinkList {
  variant?: "primary" | "secondary";
}

// Styles

export const StyledLinkList = styled.ul<StyledLinkList>`
  ${({ theme: { space, colors, media }, variant }) => css`
    a {
      width: 100%;
      padding: ${variant === "primary"
        ? `${space.fluidXSmallToSmall} 0`
        : `${space.fluidXxxSmallToXxSmall} 0`};
      justify-content: space-between;
    }

    li {
      &:first-of-type {
        a {
          padding-top: 0;
        }
      }
      &:last-of-type {
        a {
          padding-bottom: 0;
        }
      }
    }

    ${variant === "primary" &&
    css`
      li + li {
        border-top: 1px solid currentColor;
      }
    `}
  `};
`;

// JSX

export const LinkList: FC<LinkListProps> = ({
  items,
  variant = "primary",
  onClick,
  ...rest
}) => {
  return (
    <StyledLinkList variant={variant} {...rest}>
      {items?.map(({ url, label, target, id }, index) => (
        <li key={id || index}>
          <Link
            url={url}
            label={label}
            target={target}
            variant={variant}
            dataLayerClickContext="Link list"
            onClick={onClick}
          />
        </li>
      ))}
    </StyledLinkList>
  );
};

export default LinkList;
